<!--
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2022-11-22 13:11:54
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2023-09-13 09:03:32
 * @FilePath: \plantingSubsidy_web\src\views\statistics-charts\insurance-statistics\components\CompleteRadioAll\index.vue
 * @Description: 承保理赔一张图-统计承保统计图- 最新   承保理赔一张图-统计承保统计图- 最新  各保险公司承保情况-右侧
-->
<template>
  <div class="chart_box">
    <!-- 水稻图表-->

    <chart-for ref="chartForPage" :chartData="chartData1" label="水稻政策保险" />

    <!-- 玉米图表 -->

    <chart-for ref="chartForPage" :chartData="chartData2" label="玉米政策保险" />

    <!-- 大豆图表 -->

    <chart-for ref="chartForPage" :chartData="chartData3" label="大豆政策保险" />

    <!-- 小麦图表 -->
    <chart-for ref="chartForPage" :chartData="chartData4" label="小麦政策保险" />

  </div>
</template>
<script>
import ChartFor from './ChartFor'
import moment from 'moment'
export default {
  components: { ChartFor },
  data () {
    return {
      chartData1: {},
      chartData2: {},
      chartData3: {},
      chartData4: {}

    }
  },

  mounted () {

  },
  methods: {
    initData ({chartData1, chartData2, chartData3, chartData4}) {
      this.chartData1 = chartData1
      this.chartData2 = chartData2
      this.chartData3 = chartData3
      this.chartData4 = chartData4
    }

  }

}
</script>
<style lang="less" scoped>
.chart_box {
  display: flex;
  height: 100%;
  align-items: center;
  text-align: center;
  position: relative;

}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/components/v1/CompleteRadioAll/index.vue